import * as React from 'react';

import { RouteComponentProps, withRouter } from 'react-router';
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import {
    login, signup, forgotPassword, getUser,
} from '../../auth/state/actions/user';
import { resetSpecialAccessState } from '../state/actions';
import SignupForSpecialAccessModalComponent from '../components/SignupForSpecialAccessModalComponent';
import { openModal, closeModal } from '../../../actions/modal';
import IGiftLink from '../../../types/models/IGiftLink';
import IOfferSource from '../../../types/models/IOfferSource';
import IPublisherEmbedSource from '../../../types/models/IPublisherEmbedSource';
import IUser from '../../../types/models/IUser';
import { IState } from '../../../reducers';
import ISpecialAccessResponse from '../types/ISpecialAccessResponse';

interface ILocalProps {
    open: boolean;
    close: any;
}

interface IPropsFromState {
    open: boolean;
    user?: IUser;
    giftLink?: IGiftLink;
    publisherEmbedSource?: IPublisherEmbedSource;
    offerSource?: IOfferSource;
    email: string;
    accessData: ISpecialAccessResponse;
    authError?: Error;
}

interface IPropsFromDispatch {
    login: typeof login;
    signup: typeof signup;
    forgotPassword: typeof forgotPassword;
    getUser: typeof getUser;
    openModal: typeof openModal;
    resetSpecialAccessState: typeof resetSpecialAccessState;
}

interface ILocalState {
    name: string;
    password: string;
}

class SignupForSpecialAccessModal extends React.Component<ILocalProps & IPropsFromState & IPropsFromDispatch & RouteComponentProps, ILocalState> {
    public render() {
        return <SignupForSpecialAccessModalComponent {...this.props} />;
    }
}

function mapStateToProps(state: IState, ownProps: ILocalProps): IPropsFromState {
    return {
        open: ownProps.open,
        user: state.user ? state.user.user : undefined,
        giftLink: state.userSource.giftLink,
        publisherEmbedSource: state.userSource.publisherEmbedSource,
        offerSource: state.userSource.offerSource,
        email: state.specialAccess.email,
        accessData: state.specialAccess.accessData,
        authError: state.user.error,
    };
}

function mapDispatchToProps(dispatch: Dispatch): IPropsFromDispatch {
    return bindActionCreators(
        {
            openModal,
            login,
            forgotPassword,
            signup,
            getUser,
            closeModal,
            resetSpecialAccessState,
        },
        dispatch,
    );
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SignupForSpecialAccessModal));
